/**
 * Route tree — manually maintained until TanStack Router codegen is wired in CI.
 * Replace with the generated file once `@tanstack/router-vite-plugin` is added.
 */
import { createRootRoute, createRoute } from "@tanstack/react-router";

import { RootLayout } from "./components/RootLayout";
import { DashboardPage } from "./features/dashboard/DashboardPage";
import { ExportPage } from "./features/export/ExportPage";
import { TemplateBuilderPage } from "./features/templates/TemplateBuilderPage";
import { TemplateLibraryPage } from "./features/templates/TemplateLibraryPage";
import { UploadPage } from "./features/upload/UploadPage";

const rootRoute = createRootRoute({ component: RootLayout });

const uploadRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/",
  component: UploadPage,
});
const dashboardRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/dashboard",
  component: DashboardPage,
});
const templatesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/templates",
  component: TemplateLibraryPage,
});
const templateNewRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/templates/new",
  component: TemplateBuilderPage,
});
const templateEditRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/templates/$templateId/edit",
  component: TemplateBuilderPage,
});
const exportRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/export",
  component: ExportPage,
});

export const routeTree = rootRoute.addChildren([
  uploadRoute,
  dashboardRoute,
  templatesRoute,
  templateNewRoute,
  templateEditRoute,
  exportRoute,
]);
